/**
 * External URL helpers
 */

export const urls = {
  /**
   * Timelog marketing website URLs
   */
  web: {
    /**
     * Returns the base marketing website URL
     * @param locale - The locale code (e.g. 'en', 'da')
     * @returns The base website URL for the given locale
     */
    base: (locale: string = 'en') => `https://timelog.com/${locale}/`,
  },

  /**
   * Help center URLs
   */
  helpCenter: {
    /**
     * Returns the base help center URL
     * @param locale - The locale code (e.g. 'en', 'da')
     * @returns The base help center URL for the given locale
     */
    base: (locale: string = 'en') => `https://help.timelog.com/${locale}`,
  },
};
